export class FilterOption {
  key: string;
  label: string;
  controlType: string;
  controlData?: any = [];
  controlDataBindLabel?: string;
  controlDataBindValue?: string;
  chipLabel?: string;
  sequenceNumber?: number = 0;
  filterValue?: any;
  filterOperator?: any;
  fromDateValidateFilter?: any;
  toDateValidateFilter?: any;
  fromFilterValue?: any;
  toFilterValue?: any;
  isMultiSelect?: boolean = true;
}
